import { render, staticRenderFns } from "./AssignToRide.vue?vue&type=template&id=6c194edf&scoped=true"
import script from "./AssignToRide.vue?vue&type=script&lang=js"
export * from "./AssignToRide.vue?vue&type=script&lang=js"
import style0 from "./AssignToRide.vue?vue&type=style&index=0&id=6c194edf&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6c194edf",
  null
  
)

export default component.exports